import { Champion, ChampionsResponse } from '@/app/types/profile';
import { formatProfileImageUrl } from '@/utils/urls';

function normalizeChampion(champion: Champion): Champion {
  if (!champion) return champion;
  return {
    ...champion,
    profile_image: formatProfileImageUrl(champion.profile_image),
  };
}

async function championsFetch(path = ''): Promise<any> {
  const url = path ? `/api/champions?external_id=${encodeURIComponent(path)}` : '/api/champions';
  const response = await fetch(url, {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  });
  if (!response.ok) throw new Error(`Champions API error ${response.status} for ${url}`);
  return response.json();
}

export const getAllChampions = async (): Promise<Champion[] | null> => {
  try {
    const data: ChampionsResponse = await championsFetch();
    const results = Array.isArray(data.results) ? data.results : null;
    return results ? results.map(normalizeChampion) : null;
  } catch (err) {
    console.error('getAllChampions error:', err);
    return null;
  }
};

export const getChampionByExternalId = async (externalId: string): Promise<Champion | null> => {
  try {
    const data = await championsFetch(externalId);
    if (data?.results?.uuid) return normalizeChampion(data.results as Champion);
    if (Array.isArray(data?.results) && data.results[0]) return normalizeChampion(data.results[0]);
    return null;
  } catch (err) {
    console.error('getChampionByExternalId error:', err);
    return null;
  }
};
